import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UiKitModule } from '../ui-kit/ui-kit.module';
import { FieldInspectionRoutingModule } from './field-inspection-routing.module';
import { InspectionFormComponent, AnalysisDataDialogComponent } from './components/inspection-form/inspection-form.component';
import { ReportListComponent } from './components/report-list/report-list.component';
import { FindingDetailModalComponent } from './components/finding-detail-modal/finding-detail-modal.component';
import { ImageViewerDialogComponent } from './components/image-viewer-dialog/image-viewer-dialog.component';
import { FindingsSectionComponent } from './components/findings-section/findings-section.component';
import { ContextualDataPanelComponent } from './components/contextual-data-panel/contextual-data-panel.component';
import { ConfirmDeleteReportDialogComponent } from './components/confirm-delete-report-dialog/confirm-delete-report-dialog.component';

@NgModule({
  declarations: [
    InspectionFormComponent,
    AnalysisDataDialogComponent,
    ReportListComponent,
    FindingDetailModalComponent,
    ImageViewerDialogComponent,
    FindingsSectionComponent,
    ContextualDataPanelComponent,
    ConfirmDeleteReportDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatStepperModule,
    MatTooltipModule,
    UiKitModule,
    FieldInspectionRoutingModule
  ],
  exports: [
    ReportListComponent,
    InspectionFormComponent
  ]
})
export class FieldInspectionModule {}
